import { StationType } from '@mi-front/core';
import { defineMessages, MessageDescriptor } from 'react-intl';

/**
 * Station type labels (defaults from es.json).
 * Use with formatMessage so the extractor picks up the ids and defaultMessages.
 */
export const stationTypeMessages: Record<StationType, MessageDescriptor> = defineMessages({
  [StationType.STANDALONE]: {
    id: 'common.stations.type.STANDALONE',
    defaultMessage: 'Independiente',
  },
  [StationType.HEADER]: {
    id: 'common.stations.type.HEADER',
    defaultMessage: 'Cabecera',
  },
  [StationType.REPEATER]: {
    id: 'common.stations.type.REPEATER',
    defaultMessage: 'Repetidora',
  },
  [StationType.AFFILIATE]: {
    id: 'common.stations.type.AFFILIATE',
    defaultMessage: 'Afiliada',
  },
});

/**
 * Station filter option type labels – long variant (defaults from es.json).
 */
export const stationFilterOptionTypeLongMessages: Record<string, MessageDescriptor> =
  defineMessages({
    stationType: {
      id: 'ui.stationsFilter.optionType.long.stationType',
      defaultMessage: 'Tipo de emisora',
    },
    stationGroup: {
      id: 'ui.stationsFilter.optionType.long.stationGroup',
      defaultMessage: 'Grupo de emisoras',
    },
    individualStation: {
      id: 'ui.stationsFilter.optionType.long.individualStation',
      defaultMessage: 'Emisora individual',
    },
  });

/**
 * Station filter option type labels – short variant (defaults from es.json).
 */
export const stationFilterOptionTypeShortMessages: Record<string, MessageDescriptor> =
  defineMessages({
    stationType: {
      id: 'ui.stationsFilter.optionType.short.stationType',
      defaultMessage: 'Tipo',
    },
    stationGroup: {
      id: 'ui.stationsFilter.optionType.short.stationGroup',
      defaultMessage: 'Grupo',
    },
    individualStation: {
      id: 'ui.stationsFilter.optionType.short.individualStation',
      defaultMessage: 'Emisora',
    },
  });
